import {useSearchParams} from "react-router-dom";

export const useQuery = (value: string): string => {
    const [searchParams] = useSearchParams();
    return searchParams.get(value) || '';
}